import { createRouter, createWebHistory } from 'vue-router'
import { isUserLoggedIn } from '@/@core/auth/utils'
import { mobileMenuStore } from '@/stores/mobile-menu'

import HomeView from '../views/HomeView.vue'
import NotFoundView from '../views/NotFound.vue'
import accountRoutes from './routes/account'
import orderRoutes from './routes/order'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/start',
      redirect: '/',
    },

    {
      path: '/status',
      name: 'status',
      component: () => import('@/views/StatusView.vue'),
      meta: { requiresAuth: false },
    },

    {
      path: '/:packageSlug',
      name: 'special-package',
      component: HomeView,
    },

    ...accountRoutes,
    ...orderRoutes,

    {
      path: '/not-found',
      name: 'not-found',
      component: NotFoundView,
    },

    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'not-found' },
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (to.meta.requiresAuth && !isLoggedIn) {
    return next({
      name: 'account-login',
      query: { redirect: to.fullPath },
    })
  }

  if (to.meta.requiresAuth && isLoggedIn) {
    return next()
  }

  return next()
})

router.afterEach(() => mobileMenuStore.close())

export default router
